export enum SubscriptionPlan {
  FREEMIUM = 'FREEMIUM',
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM'
}
